// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:1024px){#ModalStage .modal-mask.audio-player-modal .modal-wrapper .modal-container{width:60%}}", ""]);
// Exports
module.exports = exports;
